import React from "react"
import { PageProps, Link, graphql } from "gatsby"
import SwiperCore, { Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

import { routes } from "../utils/routes"
import Layout from "../components/Layout"
import SEO from "@/components/SEO"
import Form from "@/components/Pledge/Form"
import WistiaPlayer from "@/components/WistiaPlayer"

SwiperCore.use([Navigation])

export const pageQuery = graphql`
  query PledgePageQuery {
    allGoogleSpreadsheetSheet1 {
      edges {
        node {
          name
          content
        }
      }
    }
  }
`

const Pledge: React.FC<PageProps> = ({ data }) => (
  <Layout
    sectionOne={
      <>
        <div className="relative h-[67vh] md:min-h-screen bg-[#131313]">
          <video
            className="absolute inset-0 w-full h-full object-contain md:object-cover z-0"
            playsInline
            autoPlay
            muted
            loop
          >
            <source src="https://rbai-foundation.s3-eu-west-1.amazonaws.com/videos/2025/RBAI-PAVIOUR-LOOP-V3.mp4" type="video/mp4" />
          </video>

          {/* Gold four-option bar below the fold */}
          <div className="absolute bottom-0 left-0 right-0 bg-primary w-full h-[33vh] md:h-auto md:block -mb-16 md:mb-0 z-10">
            <div className="flex flex-col h-full w-full md:grid md:grid-cols-4 md:gap-0 md:items-stretch md:min-h-[84px]">
              <a href={routes.socialMobility()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Transformative Bursaries
              </a>
              <a href={routes.southWingDevelopment()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                The South Wing
              </a>
              <a href={routes.pledge()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Sponsor a Paviour
              </a>
              <a href={routes.donate()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2">
                Donate
              </a>
            </div>
          </div>
        </div>
      </>
    }
  >
    <SEO title="Bricks" />

    <div className="py-24 bg-[#f3b247]">
        <div className="container">
          <div className="grid gap-8 grid-cols-1 md:grid-cols-2">
            <div>
              <h2 className="text-[24px] sm:text-[32px] md:text-[36px] lg:text-[42px] font-gilroy font-bold leading-[1.1] pb-4 break-words">
                Your gift will ensure that <span className="text-white">future generations of pupils</span>{" "}benefit from the same educational opportunities as you
              </h2>

              {/* <p className="leading-relaxed">
                RBAI is investing £9 million in a new Centre of Innovation for
                technology and engineering, refurbishing the science department
                and replacing our swimming pool. In support of this investment, we
                are challenging alumni, parents and friends of RBAI to help us
                raise £2.5 million.
              </p> */}

            </div>

            <WistiaPlayer
              videoStyle={{
                width: "100%",
                height: "250px",
                maxHeight: "250px"
              }}
              videoID="d78eyryj4l"
              className="max-h-[250px] aspect-video"
            />

            <p></p>

            <p className="leading-relaxed font-gilroy-light">
            See Phase I of the paviour walkway, unveiled in Spring 2022, which consists of more than 400 alumni and Instonian family names.
            </p>

            {/* <Link className="mt-8 lg:mt-16 btn btn-secondary btn-lg" to={routes.donate()}>
              DONATE IN SUPPORT OF THESE PROJECTS NOW
            </Link>

            <Link
              className="mt-8 lg:mt-16 btn btn-primary btn-lg"
              to={routes.donate()}
            >
              Watch our short film to hear staff and pupils
            </Link> */}
          </div>

        </div>
      </div>

    <div className="container py-14">
      <div>
        <Form />

        <div className="grid grid-cols-2 gap-4">
          <Link to={routes.southWingDevelopment()}>
            <img
              src="/images/thesouthwingimage.jpg"
              style={{ maxWidth: "100%" }}
              alt="The South Wing - Capital Development"
            />
          </Link>

          <Link to={routes.socialMobility()}>
            <img
              src="/images/transformational.jpg"
              style={{ maxWidth: "100%" }}
              alt="Transformative Bursaries"
            />
          </Link>
        </div>
      </div>
    </div>
  </Layout>
)

export default Pledge
